import { useContext, useEffect } from 'react';

import { LocationContext } from 'state/location';
import { MParticleContext } from 'state/mParticle';
import { routes } from 'utils/routing';

import { useFeatureHomePage } from '../features/home-page/use-feature-home-page';

export default function useLogPageView() {
  const locationContext = useContext(LocationContext);
  const { pathname } = locationContext.location;
  const mParticle = useContext(MParticleContext);
  const { homePageId } = useFeatureHomePage();

  useEffect(() => {
    // determine attributes to send to the events below
    const attrs = {
      pathname,
      sanityId: pathname === routes.base ? homePageId.featureHomePageId : '',
    };

    // mParticle page view event - uses mParticle logPageView API to track page view
    mParticle.logPageView(pathname, attrs);

    // mParticle custom event for page view - uses mParticle logEvent API to track page view
    mParticle.logCustomPageView(pathname, attrs);
  }, [pathname]); // eslint-disable-line react-hooks/exhaustive-deps
}
